export const OVERDUE = 'OVERDUE';
export const UPCOMING = 'UPCOMING';
export const HAS_LAST_CONVERSATION = 'HAS_LAST_CONVERSATION';
export const CLOSED = 'CLOSED';
